// 农历（阴历）转换，供日历组件展示农历日期（1900-2100 区间）
// 算法与常见农历库一致，lunarInfo 为 1900~2100 年的农历数据表

const lunarInfo = [
  0x04bd8, 0x04ae0, 0x0a570, 0x054d5, 0x0d260, 0x0d950, 0x16554, 0x056a0,
  0x09ad0, 0x055d2, 0x04ae0, 0x0a5b6, 0x0a4d0, 0x0d250, 0x1d255, 0x0b540,
  0x0d6a0, 0x0ada2, 0x095b0, 0x14977, 0x04970, 0x0a4b0, 0x0b4b5, 0x06a50,
  0x06d40, 0x1ab54, 0x02b60, 0x09570, 0x052f2, 0x04970, 0x06566, 0x0d4a0,
  0x0ea50, 0x06e95, 0x05ad0, 0x02b60, 0x186e3, 0x092e0, 0x1c8d7, 0x0c950,
  0x0d4a0, 0x1d8a6, 0x0b550, 0x056a0, 0x1a5b4, 0x025d0, 0x092d0, 0x0d2b2,
  0x0a950, 0x0b557, 0x06ca0, 0x0b550, 0x15355, 0x04da0, 0x0a5b0, 0x14573,
  0x052b0, 0x0a9a8, 0x0e950, 0x06aa0, 0x0aea6, 0x0ab50, 0x04b60, 0x0aae4,
  0x0a570, 0x05260, 0x0f263, 0x0d950, 0x05b57, 0x056a0, 0x096d0, 0x04dd5,
  0x04ad0, 0x0a4d0, 0x0d4d4, 0x0d250, 0x0d558, 0x0b540, 0x0b6a0, 0x195a6,
  0x095b0, 0x049b0, 0x0a974, 0x0a4b0, 0x0b27a, 0x06a50, 0x06d40, 0x0af46,
  0x0ab60, 0x09570, 0x04af5, 0x04970, 0x064b0, 0x074a3, 0x0ea50, 0x06b58,
  0x055c0, 0x0ab60, 0x096d5, 0x092e0, 0x0c960, 0x0d954, 0x0d4a0, 0x0da50,
  0x07552, 0x056a0, 0x0abb7, 0x025d0, 0x092d0, 0x0cab5, 0x0a950, 0x0b4a0,
  0x0baa4, 0x0ad50, 0x055d9, 0x04ba0, 0x0a5b0, 0x15176, 0x052b0, 0x0a930,
  0x07954, 0x06aa0, 0x0ad50, 0x05b52, 0x04b60, 0x0a6e6, 0x0a4e0, 0x0d260,
  0x0ea65, 0x0d530, 0x05aa0, 0x076a3, 0x096d0, 0x04afb, 0x04ad0, 0x0a4d0,
  0x1d0b6, 0x0d250, 0x0d520, 0x0dd45, 0x0b5a0, 0x056d0, 0x055b2, 0x049b0,
  0x0a577, 0x0a4b0, 0x0aa50, 0x1b255, 0x06d20, 0x0ada0,
];

const Gan = ["甲", "乙", "丙", "丁", "戊", "己", "庚", "辛", "壬", "癸"];
const Zhi = [
  "子",
  "丑",
  "寅",
  "卯",
  "辰",
  "巳",
  "午",
  "未",
  "申",
  "酉",
  "戌",
  "亥",
];
const Animals = [
  "鼠",
  "牛",
  "虎",
  "兔",
  "龙",
  "蛇",
  "马",
  "羊",
  "猴",
  "鸡",
  "狗",
  "猪",
];
const lunarMonths = [
  "正",
  "二",
  "三",
  "四",
  "五",
  "六",
  "七",
  "八",
  "九",
  "十",
  "冬",
  "腊",
];
const lunarDays = [
  "初一",
  "初二",
  "初三",
  "初四",
  "初五",
  "初六",
  "初七",
  "初八",
  "初九",
  "初十",
  "十一",
  "十二",
  "十三",
  "十四",
  "十五",
  "十六",
  "十七",
  "十八",
  "十九",
  "二十",
  "廿一",
  "廿二",
  "廿三",
  "廿四",
  "廿五",
  "廿六",
  "廿七",
  "廿八",
  "廿九",
  "三十",
];

const leapMonth = (y: number): number => lunarInfo[y - 1900] & 0xf;

const leapDays = (y: number): number => {
  if (leapMonth(y)) {
    return lunarInfo[y - 1900] & 0x10000 ? 30 : 29;
  }
  return 0;
};

const lunarYearDays = (y: number): number => {
  let sum = 348;
  for (let i = 0x8000; i > 0x8; i >>= 1) {
    sum += lunarInfo[y - 1900] & i ? 1 : 0;
  }
  return sum + leapDays(y);
};

const lunarMonthDays = (y: number, m: number): number =>
  lunarInfo[y - 1900] & (0x10000 >> m) ? 30 : 29;

// ===== 二十四节气（1-12 月对应 节/中气，算法移植自 wx-calendar 插件）=====
const SectionalTermNames = [
  "小寒",
  "立春",
  "惊蛰",
  "清明",
  "立夏",
  "芒种",
  "小暑",
  "立秋",
  "白露",
  "寒露",
  "立冬",
  "大雪",
];
const PrincipleTermNames = [
  "大寒",
  "雨水",
  "春分",
  "谷雨",
  "小满",
  "夏至",
  "大暑",
  "处暑",
  "秋分",
  "霜降",
  "小雪",
  "冬至",
];

const SectionalTermMap = [
  [
    7, 6, 6, 6, 6, 6, 6, 6, 6, 5, 6, 6, 6, 5, 5, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5,
    4, 5, 5,
  ],
  [
    5, 4, 5, 5, 5, 4, 4, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4, 3, 4, 4, 4, 3, 3, 4, 4,
    3, 3, 3,
  ],
  [
    6, 6, 6, 7, 6, 6, 6, 6, 5, 6, 6, 6, 5, 5, 6, 6, 5, 5, 5, 6, 5, 5, 5, 5, 4,
    5, 5, 5, 5,
  ],
  [
    5, 5, 6, 6, 5, 5, 5, 6, 5, 5, 5, 5, 4, 5, 5, 5, 4, 4, 5, 5, 4, 4, 4, 5, 4,
    4, 4, 4, 5,
  ],
  [
    6, 6, 6, 7, 6, 6, 6, 6, 5, 6, 6, 6, 5, 5, 6, 6, 5, 5, 5, 6, 5, 5, 5, 5, 4,
    5, 5, 5, 5,
  ],
  [
    6, 6, 7, 7, 6, 6, 6, 7, 6, 6, 6, 6, 5, 6, 6, 6, 5, 5, 6, 6, 5, 5, 5, 6, 5,
    5, 5, 5, 4, 5, 5, 5, 5,
  ],
  [
    7, 8, 8, 8, 7, 7, 8, 8, 7, 7, 7, 8, 7, 7, 7, 7, 6, 7, 7, 7, 6, 6, 7, 7, 6,
    6, 6, 7, 7,
  ],
  [
    8, 8, 8, 9, 8, 8, 8, 8, 7, 8, 8, 8, 7, 7, 8, 8, 7, 7, 7, 8, 7, 7, 7, 7, 6,
    7, 7, 7, 6, 6, 7, 7, 7,
  ],
  [
    8, 8, 8, 9, 8, 8, 8, 8, 7, 8, 8, 8, 7, 7, 8, 8, 7, 7, 7, 8, 7, 7, 7, 7, 6,
    7, 7, 7, 7,
  ],
  [
    9, 9, 9, 9, 8, 9, 9, 9, 8, 8, 9, 9, 8, 8, 8, 9, 8, 8, 8, 8, 7, 8, 8, 8, 7,
    7, 8, 8, 8,
  ],
  [
    8, 8, 8, 8, 7, 8, 8, 8, 7, 7, 8, 8, 7, 7, 7, 8, 7, 7, 7, 7, 6, 7, 7, 7, 6,
    6, 7, 7, 7,
  ],
  [
    7, 8, 8, 8, 7, 7, 8, 8, 7, 7, 7, 8, 7, 7, 7, 7, 6, 7, 7, 7, 6, 6, 7, 7, 6,
    6, 6, 7, 7,
  ],
];
const SectionalTermYear = [
  [13, 49, 85, 117, 149, 185, 201, 250, 250],
  [13, 45, 81, 117, 149, 185, 201, 250, 250],
  [13, 48, 84, 112, 148, 184, 200, 201, 250],
  [13, 45, 76, 108, 140, 172, 200, 201, 250],
  [13, 44, 72, 104, 132, 168, 200, 201, 250],
  [5, 33, 68, 96, 124, 152, 188, 200, 201],
  [29, 57, 85, 120, 148, 176, 200, 201, 250],
  [13, 48, 76, 104, 132, 168, 196, 200, 201],
  [25, 60, 88, 120, 148, 184, 200, 201, 250],
  [16, 44, 76, 108, 144, 172, 200, 201, 250],
  [28, 60, 92, 124, 160, 192, 200, 201, 250],
  [17, 53, 85, 124, 156, 188, 200, 201, 250],
];
const PrincipleTermMap = [
  [
    21, 21, 21, 21, 21, 20, 21, 21, 21, 20, 20, 21, 21, 20, 20, 20, 20, 20, 20,
    20, 20, 19, 20, 20, 20, 19, 19, 20,
  ],
  [
    20, 19, 19, 20, 20, 19, 19, 19, 19, 19, 19, 19, 19, 18, 19, 19, 19, 18, 18,
    19, 19, 18, 18, 18, 18, 18, 18, 18,
  ],
  [
    21, 21, 21, 22, 21, 21, 21, 21, 20, 21, 21, 21, 20, 20, 21, 21, 20, 20, 20,
    21, 20, 20, 20, 20, 19, 20, 20, 20, 20,
  ],
  [
    20, 21, 21, 21, 20, 20, 21, 21, 20, 20, 20, 21, 20, 20, 20, 20, 19, 20, 20,
    20, 19, 19, 20, 20, 19, 19, 19, 20, 20,
  ],
  [
    21, 22, 22, 22, 21, 21, 22, 22, 21, 21, 21, 22, 21, 21, 21, 21, 20, 21, 21,
    21, 20, 20, 21, 21, 20, 20, 20, 21, 21,
  ],
  [
    22, 22, 22, 22, 21, 22, 22, 22, 21, 21, 22, 22, 21, 21, 21, 22, 21, 21, 21,
    21, 20, 21, 21, 21, 20, 20, 21, 21, 21,
  ],
  [
    23, 23, 24, 24, 23, 23, 23, 24, 23, 23, 23, 23, 22, 23, 23, 23, 22, 22, 23,
    23, 22, 22, 22, 23, 22, 22, 22, 22, 23,
  ],
  [
    23, 24, 24, 24, 23, 23, 24, 24, 23, 23, 23, 24, 23, 23, 23, 23, 22, 23, 23,
    23, 22, 22, 23, 23, 22, 22, 22, 23, 23,
  ],
  [
    23, 24, 24, 24, 23, 23, 24, 24, 23, 23, 23, 24, 23, 23, 23, 23, 22, 23, 23,
    23, 22, 22, 23, 23, 22, 22, 22, 23, 23,
  ],
  [
    24, 24, 24, 24, 23, 24, 24, 24, 23, 23, 24, 24, 23, 23, 23, 24, 23, 23, 23,
    23, 22, 23, 23, 23, 22, 22, 23, 23, 23,
  ],
  [
    23, 23, 23, 23, 22, 23, 23, 23, 22, 22, 23, 23, 22, 22, 22, 23, 22, 22, 22,
    22, 21, 22, 22, 22, 21, 21, 22, 22, 22,
  ],
  [
    22, 22, 23, 23, 22, 22, 22, 23, 22, 22, 22, 22, 21, 22, 22, 22, 21, 21, 22,
    22, 21, 21, 21, 22, 21, 21, 21, 21, 22,
  ],
];
const PrincipleTermYear = [
  [13, 45, 81, 113, 149, 185, 201],
  [21, 57, 93, 125, 161, 193, 201],
  [21, 56, 88, 120, 152, 188, 200, 201],
  [21, 49, 81, 116, 144, 176, 200, 201],
  [17, 49, 77, 112, 140, 168, 200, 201],
  [28, 60, 88, 116, 148, 180, 200, 201],
  [25, 53, 84, 112, 144, 172, 200, 201],
  [29, 57, 89, 120, 148, 180, 200, 201],
  [17, 45, 73, 108, 140, 168, 200, 201],
  [28, 60, 92, 124, 160, 192, 200, 201],
  [16, 44, 80, 112, 148, 180, 200, 201],
  [17, 53, 88, 120, 156, 188, 200, 201],
];

const sectionalTerm = (y: number, m: number): number => {
  if (y < 1901 || y > 2100) return 0;
  const years = SectionalTermYear[m - 1];
  const days = SectionalTermMap[m - 1];
  let index = 0;
  const ry = y - 1900;
  while (index < years.length && ry >= years[index]) index++;
  return days[4 * index + (ry % 4)];
};

const principleTerm = (y: number, m: number): number => {
  if (y < 1901 || y > 2100) return 0;
  const years = PrincipleTermYear[m - 1];
  const days = PrincipleTermMap[m - 1];
  let index = 0;
  const ry = y - 1900;
  while (index < years.length && ry >= years[index]) index++;
  return days[4 * index + (ry % 4)];
};

// 个别年份节气日期有误差，需要修正
const SolarTermRevises = [
  { solar: SectionalTermNames[2], year: 2014, month: 3, wrong: 5, correct: 6 },
  {
    solar: PrincipleTermNames[2],
    year: 2051,
    month: 3,
    wrong: 21,
    correct: 20,
  },
  { solar: SectionalTermNames[1], year: 2083, month: 2, wrong: 4, correct: 3 },
  {
    solar: PrincipleTermNames[2],
    year: 2084,
    month: 3,
    wrong: 20,
    correct: 19,
  },
  { solar: SectionalTermNames[5], year: 2094, month: 6, wrong: 6, correct: 5 },
];

// 农历节日（农历月_日）
const LunarFestivals: Record<string, string> = {
  "1_1": "春节",
  "1_15": "元宵节",
  "2_2": "龙抬头",
  "5_5": "端午节",
  "7_7": "七夕节",
  "8_15": "中秋节",
  "9_9": "重阳节",
  "12_8": "腊八节",
  "12_23": "小年",
};

// 公历节日（公历月_日）
const SolarFestivals: Record<string, string> = {
  "1_1": "元旦",
  "2_14": "情人节",
  "3_8": "妇女节",
  "3_12": "植树节",
  "4_1": "愚人节",
  "5_1": "劳动节",
  "5_4": "青年节",
  "6_1": "儿童节",
  "7_1": "建党节",
  "8_1": "建军节",
  "9_10": "教师节",
  "10_1": "国庆节",
  "12_24": "平安夜",
  "12_25": "圣诞节",
};

/** 返回当天节气名（如 立春），非节气返回 null */
export const solarTermOf = (
  year: number,
  month: number,
  day: number
): string | null => {
  if (year < 1901 || year > 2100) return null;
  const revise = SolarTermRevises.find(
    (r) => r.year === year && r.month === month
  );
  if (revise) {
    if (revise.wrong === day) return null;
    if (revise.correct === day) return revise.solar;
  }
  if (day === sectionalTerm(year, month)) return SectionalTermNames[month - 1];
  if (day === principleTerm(year, month)) return PrincipleTermNames[month - 1];
  return null;
};

export interface LunarDateInfo {
  lunarYear: number;
  lunarMonth: number;
  lunarDay: number;
  isLeap: boolean;
  /** 例如 2026 丙午年 */
  lunarYearCN: string;
  /** 例如 正月 */
  lunarMonthCN: string;
  /** 例如 初一 */
  lunarDayCN: string;
  /** 节气名（如 立春），无则 null */
  lunarTerm: string | null;
  /** 节日名（农历节日优先，其次公历节日），无则 null */
  festival: string | null;
}

// 阳历转农历，入参 year/month/day 为阳历
export const toLunar = (
  year: number,
  month: number,
  day: number
): LunarDateInfo | null => {
  if (year < 1900 || year > 2100) return null;

  // 计算阳历日期与 1900/1/31（农历1900年正月初一）相差的天数
  let offset =
    (Date.UTC(year, month - 1, day) - Date.UTC(1900, 0, 31)) / 86400000;

  let i: number;
  let temp = 0;
  for (i = 1900; i < 2101 && offset > 0; i++) {
    temp = lunarYearDays(i);
    offset -= temp;
  }
  if (offset < 0) {
    offset += temp;
    i--;
  }

  const lunarYear = i;
  const leap = leapMonth(i); // 闰哪个月
  let isLeap = false;

  for (i = 1; i < 13 && offset > 0; i++) {
    if (leap > 0 && i === leap + 1 && !isLeap) {
      --i;
      isLeap = true;
      temp = leapDays(lunarYear);
    } else {
      temp = lunarMonthDays(lunarYear, i);
    }
    if (isLeap && i === leap + 1) {
      isLeap = false;
    }
    offset -= temp;
  }

  if (offset === 0 && leap > 0 && i === leap + 1) {
    if (isLeap) {
      isLeap = false;
    } else {
      isLeap = true;
      --i;
    }
  }
  if (offset < 0) {
    offset += temp;
    --i;
  }

  const lunarMonth = i;
  const lunarDay = offset + 1;

  const cY = lunarYear - 1900 + 36;
  const cG = cY % 10;
  const cZ = cY % 12;

  // 节气优先于节日（优先显示节气），节日与农历初一互斥
  const lunarTerm = solarTermOf(year, month, day);
  let festival: string | null = null;
  if (!isLeap) {
    festival = LunarFestivals[`${lunarMonth}_${lunarDay}`] || null;
    // 除夕 = 农历最后一天（腊月大尽/小尽）
    if (
      !festival &&
      lunarMonth === 12 &&
      lunarDay === lunarMonthDays(lunarYear, 12)
    ) {
      festival = "除夕";
    }
  }
  if (!festival) festival = SolarFestivals[`${month}_${day}`] || null;

  return {
    lunarYear,
    lunarMonth,
    lunarDay,
    isLeap,
    lunarYearCN: `${Gan[cG]}${Zhi[cZ]}${Animals[cZ]}年`,
    lunarMonthCN: (isLeap ? "闰" : "") + lunarMonths[lunarMonth - 1] + "月",
    lunarDayCN: lunarDays[lunarDay - 1],
    lunarTerm,
    festival,
  };
};
